const inject = ['shipmentOrchestrator', '$q', 'analytics', '$state'];

const FORBIDDEN_STATUS_MESSAGE = 'The user is not authenticated or hasn\'t subscribed to any product yet.';

function LayoutControllerFactory(shipmentOrchestrator, $q, analytics, $state) {
  class LayoutController {
    constructor() {
      this.loading = true;

      this.handleForbiddenResponse = this.handleForbiddenResponse.bind(this);
    }

    $onInit() {
      this.loading = true;

      return $q.all([
        this.getUnsentShipments(),
        this.getSentShipments()
      ])
        .catch(this.handleForbiddenResponse)
        .finally(() => {
          analytics.logPageView();

          this.loading = false;
        });
    }

    hasNoUpcomingShipments() {
      return this.unsentShipments.length + this.sentShipments.length === 0;
    }

    showUnsentShipments() {
      return this.unsentShipments.length > 0;
    }

    showSentShipments() {
      return this.sentShipments.length > 0;
    }

    getUnsentShipments() {
      return shipmentOrchestrator.getUnsentShipments().then((data) => {
        this.unsentShipments = data;
      });
    }

    getSentShipments() {
      return shipmentOrchestrator.getSentShipments().then((data) => {
        this.sentShipments = data;
      });
    }

    handleForbiddenResponse(response) {
      let message = response;
      if (response.status === 403) {
        $state.go('forbidden');
        message = FORBIDDEN_STATUS_MESSAGE;
      }
      return $q.reject(message);
    }
  }

  return new LayoutController();
}

LayoutControllerFactory.$inject = inject;

angular.module('msi.layout')
  .controller('LayoutController', LayoutControllerFactory);

module.exports = LayoutControllerFactory;
